import * as DBTypes from "./database"

export interface Dictionary<T> {
    [key: string]: T;
}
export interface IntegerDictionary<T> {
    [key: number]: T;
}

export namespace VectorMath {

	/**
	 * Represents a 2D vector with x and y components.
	 */
	export class Vector2 {
		x:number
		y:number

		  /**
		 * Creates a new Vector2D instance.
		 * @param {number} [x=0] - The x component.
		 * @param {number} [y=0] - The y component.
		 */
		constructor(x = 0, y = 0) {
			/** @type {number} */
			this.x = x;
			/** @type {number} */
			this.y = y;
		}
	}
}

export namespace PNCTypes {

	export enum EpisodeCategory {
		NORMAL = 0,
		DARK = 1
	}

	export enum AvgContentType {
		NORMAL = 0,
		//No text is displayed. Not sure what this does.
		UNKNOWN = 4
	}

	export enum AvgImageType {
		UNKNOWN_1 = 1,  //Seems to be backgrounds still
		BACKGROUND = 2,
		CHARACTER = 3,
		MULTILAYER_BG = 4, //On top of normal background?
		VIDEO = 5
	};


	//This is a type from the game so it's a bit confusing to deal with...
	export interface AvgImage {
		imgPath:string,
		imgPathBoy?:string,
		imgType:PNCTypes.AvgImageType,
		/**Controls the transparency of the loaded image. 0 = invisible, 1 = visible. This is a float, so decimals are also valid. */
		alpha:number,
		imgId:number,
	}

	export interface AvgPortrait extends AvgImage {
		faceId:number;
		comm:boolean
		//This is added by the interpreter, it really shouldn't be part of AvgPortrait but whatever
		face?:number;
		//Also added by the interpreter at runtime since we have to store it somewhere
		posId?:number;
	}
	
	export interface AvgBackground extends AvgImage {
		fullScreen:boolean
		/**Unknown behavior */
		delete:boolean
	}

	export interface AvgTweenData {
		imgId:number;
		delay:number;
		duration:number;
		alpha?:number;
		isDark:boolean;
		shake?:boolean;
		posId?:number;
	}

	export interface NounData {
		type:number;
		name:string;
		avg_order:string;
		id:number;
		pre_para?:object;
		des:string;
	}

	export interface Episode extends DBTypes.Episode {
		chapterName:string;
	}

	export interface Chapter extends DBTypes.Chapter {
		episodes:Episode[];
	}

	// This is a "literal" type that contains the names of the properties
	// So if you do func(arg:StoryCategory) {}
	// That means you can only have the literal strings main, event, side, crossover as arguments
	export type StoryCategory = keyof DBTypes.StoryDatabase;

	export interface StoryDatabase extends DBTypes.StoryDatabase {
		//This value is inserted when loading!!
		__hashtable:Dictionary<DBTypes.Episode>;
		/** Contains an array of permalinks matching the order of __hashtable */
		__indexes:string[];
	}
	export interface Database extends DBTypes.PNCDatabase {
		story: StoryDatabase;
	}


}

export enum LANGUAGE {
	ENGLISH,
	CHINESE,
	JAPANESE,
	KOREAN,
	RUSSIAN
}

export const LANGUAGE_NAMES = {
	"English":"en/",
	"汉语 (Chinese)":"cn/",
	"日本語 (Japanese)":"jp/",
	"한국어 (Korean)":"kr/",
	"русский (Russian)":"ru/",
	//"Zalgo (DEBUG)":"za/"
};
//export const LANGUAGE_INDEX = Object.values(LANGUAGE_NAMES)
export type LanguageCode = "en/" | "cn/" | "jp/" | "kr/" | "ru/" | "za/";
//This doesn't work... VSCode thinks it's still a string
//export type LanguageCode = typeof LANGUAGE_NAMES[keyof typeof LANGUAGE_NAMES];


export function isCutsceneType(type:DBTypes.StoryType):boolean {
	return type == DBTypes.StoryType.STORY_ONLY || 
	type == DBTypes.StoryType.DURING_BATTLE || 
	type == DBTypes.StoryType.BETWEEN_STAGES;
}